import { useCallback } from 'react';

import { PlayIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import Brand from '@/components/atoms/Icons/Navigation/Brand';
import Whatsapp from '@/components/atoms/Icons/Whatsapp';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface TestAgentButtonProps {
  disabled: boolean;
  hasWhatsApp: boolean;
  onClickMoveo: () => void;
  onClickWhatsApp: () => void;
  onOpenChange?: (open: boolean) => void;
}

const TestAgentButton = ({
  disabled,
  hasWhatsApp,
  onClickMoveo,
  onClickWhatsApp,
  onOpenChange,
}: TestAgentButtonProps) => {
  const { t } = useTranslation();

  const handleSelectMoveo = useCallback(() => {
    onClickMoveo();
  }, [onClickMoveo]);

  const handleSelectWhatsApp = useCallback(() => {
    onClickWhatsApp();
  }, [onClickWhatsApp]);

  const handleOpenChange = useCallback(
    (open: boolean) => {
      if (disabled) {
        onOpenChange?.(false);
        return;
      }
      onOpenChange?.(open);
    },
    [disabled, onOpenChange]
  );

  if (!hasWhatsApp) {
    return (
      <Button variant="outline-neutral" size="sm" disabled={disabled} onClick={onClickMoveo}>
        <PlayIcon size={16} />
        {t('common.test')}
      </Button>
    );
  }

  return (
    <DropdownMenu onOpenChange={handleOpenChange}>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <Button variant="outline-neutral" size="sm" disabled={disabled}>
          <PlayIcon size={16} />
          {t('common.test')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent onCloseAutoFocus={(e) => e.preventDefault()} align="end">
        <DropdownMenuItem onSelect={handleSelectMoveo}>
          <Brand size={16} color="var(--primary)" />
          {t('common.test_moveo')}
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={handleSelectWhatsApp}>
          <Whatsapp size={16} />
          {t('common.test_whatsapp')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default TestAgentButton;
